import redirector from "../util/redirector";
import { authClientApplication } from "./authClientApplication";
export default function getHeadersWithToken() {
    const accounts = authClientApplication.getAllAccounts();

    return authClientApplication.acquireTokenSilent({
        scopes:["user.read"],
        account: accounts[0]
    }).then(result => {
        return {
            'Authorization': `Bearer ${result.idToken}`
        };
    }).catch(ex => {
        // geen actieve login gevonden
        redirector.goTo("/noAccess");
    });
}